export class LFO {
    constructor(ctx) {
        this.ctx = ctx;
        this.osc = this.ctx.createOscillator();
        this.gain = this.ctx.createGain(); // Depth control
        
        this.osc.frequency.value = 1.0; // Default 1 Hz
        this.gain.gain.value = 100; // Default Depth
        
        this.osc.connect(this.gain);
        this.osc.start();
        
        this.connectedParams = [];
    }

    setRate(rate) {
        const now = this.ctx.currentTime;
        this.osc.frequency.cancelScheduledValues(now);
        this.osc.frequency.setTargetAtTime(rate, now, 0.01);
    }

    setDepth(depth) {
        const now = this.ctx.currentTime;
        console.log(`[LFO] Depth: ${depth}`);
        this.gain.gain.cancelScheduledValues(now);
        this.gain.gain.setTargetAtTime(depth, now, 0.01);
    }

    setWaveform(type) {
        this.osc.type = type;
    }

    connect(audioParam) {
        if (audioParam) {
            try {
                this.gain.connect(audioParam);
                this.connectedParams.push(audioParam);
                console.log(`[LFO] Connected to param. Current value: ${audioParam.value}`);
            } catch (e) {
                console.error(`[LFO] Failed to connect:`, e);
            }
        }
    }

    disconnect() {
        this.connectedParams.forEach(p => {
            try {
                this.gain.disconnect(p);
            } catch (e) {
                // Ignore if already disconnected
            }
        });
        this.connectedParams = [];
    }
}
